import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const CaC = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Using purified CRP and the built lateral flow assay platform, we will run the test with different concentrations of CRP and correlate them with the number of lines that can be formed. In the process we will evaluate as well the minimum and maximum concentration of protein that our system can detect; meaning the minimum concentration of CRP for us to see a soft red line and the maximum concentration of CRP where all possible lines are in dark red color. In the future, we will repeat this assay with different types of samples (blood, serum and plasma) and different lengths of strips to optimize the system.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/14.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 13. Diagram of calibration curve protocol. Created with BioRender.com.</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default CaC;
